<template>
  <div class="body">
    <van-nav-bar title="新增收货地址" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content animated fadeInRight fast">
      <van-address-edit
        :area-list="areaList"
        show-search-result
        @save="onSave"
      />
    </div>
  </div>
</template>

<script>
import { AddressEdit } from "vant";
import Vue from "vue";
Vue.use(AddressEdit);
import area from "../../utils/area.js";
import { AddAddress } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
export default {
  data() {
    return {
      areaList : {}
    };
  },
  created() {
      this.areaList=area;
  },
  methods: {
    onClickLeft() {
        this.$router.go(-1);
    },
    onSave(addressInfo) {
        let name= addressInfo.name;
        let phone= addressInfo.tel;
        let detail= addressInfo.addressDetail;
        let region= `${addressInfo.province},${addressInfo.city},${addressInfo.county}`;
        let token = getLocalStorage('login_token');
        this.AddAddress(name,phone,detail,region,token)
    },
    AddAddress(name,phone,detail,region,token){
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中"
      });
        AddAddress(name,phone,detail,region,token).then(res =>{
            if(res.code==1){
              this.$toast.clear();
                this.$router.go(-1);
            }else{
              this.$toast.clear();
                this.$toast.fail("添加失败");
            }
        }).catch(e=>{})
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 46px;
  }
}
</style>
<style>
.body .van-button{
  background-color: #e9aea8 !important;
  border: 0.026667rem solid #e9aea8 !important;
}
</style>
